// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.2.0",
  date: "2026-06-23T07:17:26.105Z",
  gitInfo: {
    dirty: false,
    raw: "d58b5a1a0",
    hash: "d58b5a1a0",
    distance: null,
    tag: null,
    semver: null,
    suffix: "d58b5a1a0",
    semverString: null
  }
};
/* tslint:enable */
